import type { Entity } from '../../components/AdminSettings/Entity/types';
import { OAuthClientEntity } from './OAuthClientEntity';
import { SecureStoreEntityType } from './types';

export const SecureStoreEntitiesMap = new Map<SecureStoreEntityType, Entity<any, SecureStoreEntityType>>([
  [SecureStoreEntityType.OAuthClient, OAuthClientEntity],
]);
